// Generated by /client/scripts/generate-icon-components.mjs
// DO NOT EDIT DIRECTLY

import type React from "react";

import reverseLeftIcon from "@/assets/icons/reverse-left.svg";

import { Icon, type IconProps } from "../Icon/Icon";

type ReverseLeftIconProps = Omit<IconProps, "name">;

export function ReverseLeftIcon(props: ReverseLeftIconProps): React.ReactNode {
  return <Icon name={reverseLeftIcon} {...props} />;
}
